import { createPublicAPI } from 'lib/utils/fetch/create-api-factory';
import { z } from 'zod';

export const uploadImages = createPublicAPI({
  url: `${process.env.NEXT_PUBLIC_MEDIA_SERVICE_URL}/images`,
  method: 'POST',
  schema: z.object({
    errors: z.array(z.any()),
    success: z.array(
      z.object({
        id: z.string(),
        filename: z.string(),
      }),
    ),
  }),
});
